import React from 'react';
import About from '../components/about';
import Footer from '../components/footer';
import Header from '../components/header';
import Nav from '../components/nav';
import Team from '../components/team';
import Clients from '../components/clients';
import Blog from '../components/blog';

export default function Home() {
  return (
    <>
      <Nav />
      <main>
        <Header />
        <About />
        <Team />
        <Clients />
        <Blog />
      </main>
      <Footer />
    </>
  );
}
